var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { capitalize } from '@ember/string';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let LISTING_STATUS = /*#__PURE__*/function (LISTING_STATUS) {
  LISTING_STATUS["DISABLED"] = "DISABLED";
  LISTING_STATUS["PENDING"] = "PENDING";
  LISTING_STATUS["PUBLISHED"] = "PUBLISHED";
  LISTING_STATUS["UNPUBLISHED"] = "UNPUBLISHED";
  LISTING_STATUS["INVALID"] = "INVALID";
  LISTING_STATUS["ERROR"] = "ERROR";
  LISTING_STATUS["RECOMMENDED"] = "RECOMMENDED";
  LISTING_STATUS["NEEDS_ATTENTION"] = "NEEDS_ATTENTION";
  return LISTING_STATUS;
}({});
export let ACKNOWLEDGMENT_STATUS = /*#__PURE__*/function (ACKNOWLEDGMENT_STATUS) {
  ACKNOWLEDGMENT_STATUS["PENDING"] = "PENDING";
  ACKNOWLEDGMENT_STATUS["SUCCESS"] = "SUCCESS";
  ACKNOWLEDGMENT_STATUS["USER_ERROR"] = "USER_ERROR";
  ACKNOWLEDGMENT_STATUS["USER_WARNING"] = "USER_WARNING";
  ACKNOWLEDGMENT_STATUS["SYSTEM_ERROR"] = "SYSTEM_ERROR";
  return ACKNOWLEDGMENT_STATUS;
}({});
export let CHANNEL_STATUS = /*#__PURE__*/function (CHANNEL_STATUS) {
  CHANNEL_STATUS["DISABLED"] = "DISABLED";
  CHANNEL_STATUS["UNPUBLISHED"] = "UNPUBLISHED";
  CHANNEL_STATUS["PUBLISHED"] = "PUBLISHED";
  return CHANNEL_STATUS;
}({});
var UpdateDirection = /*#__PURE__*/function (UpdateDirection) {
  UpdateDirection["CHANNEL"] = "CHANNEL";
  return UpdateDirection;
}(UpdateDirection || {});
var CheckForActions = /*#__PURE__*/function (CheckForActions) {
  CheckForActions[CheckForActions["FALSE"] = 0] = "FALSE";
  CheckForActions[CheckForActions["TRUE"] = 1] = "TRUE";
  return CheckForActions;
}(CheckForActions || {});
let ObjectMap = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('number'), _dec8 = attr('number'), _dec9 = attr('number'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('date'), _dec13 = attr('string'), _dec14 = attr('date'), _dec15 = attr('json-or-value'), _dec16 = attr('number'), _dec17 = attr('date'), _dec18 = attr('date'), _dec19 = attr('date'), _dec20 = attr('boolean'), _dec21 = belongsTo('channels/platform-object', {
  async: false
}), _dec22 = belongsTo('channels/channel-object', {
  async: false
}), _dec23 = hasMany('channels/object-map-acknowledgment-error', {
  async: false
}), _dec24 = hasMany('channels/object-map-field-mask'), _dec25 = belongsTo('channels/channel'), _dec26 = computed('channelStatus'), _dec27 = computed('channelStatus'), _dec28 = computed('channelStatus'), _dec29 = computed('acknowledgmentStatus'), _dec30 = computed('acknowledgmentStatus'), _dec31 = computed('acknowledgmentStatus'), _dec32 = computed('acknowledgmentStatus'), _dec33 = computed('acknowledgmentStatus'), _dec34 = computed('manuallyDisabled'), _dec35 = computed('channelObject.isApproved', 'isAcknowledgementStatusSuccess', 'isAcknowledgementStatusUserWarning', 'isChannelStatusPublished'), _dec36 = computed('isAcknowledgementStatusUserWarning'), _dec37 = computed('channelObject.{isDisapproved,isPending}', 'isAcknowledgementStatusPending', 'isAcknowledgementStatusSuccess', 'isChannelStatusPublished'), _dec38 = computed('isAcknowledgementStatusSystemError', 'isAcknowledgementStatusUserError'), _dec39 = computed('status'), _dec40 = computed('isAcknowledgementStatusSystemError', 'isAcknowledgementStatusUserError', 'isChannelStatusDisabled', 'isChannelStatusUnpublished', 'isPendingStatus', 'isPublishedStatus', 'isRecommendedStatus'), _dec41 = computed('statusToL'), _dec42 = computed('status'), _dec43 = computed('objectMapAcknowledgmentErrors.@each.isErrorTypeError'), _dec44 = computed('objectMapAcknowledgmentErrors.@each.isErrorTypeWarning'), _dec45 = computed('objectMapAcknowledgmentErrors.@each.isOccurredByChannel', 'errorTypeObjectMapAcknowledgmentErrors'), _dec46 = computed('objectMapAcknowledgmentErrors.@each.isOccurredByChannel', 'errorTypeObjectMapAcknowledgmentErrors'), _class = class ObjectMap extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "channelId", _descriptor2, this);
    _initializerDefineProperty(this, "platformObjectId", _descriptor3, this);
    _initializerDefineProperty(this, "channelObjectId", _descriptor4, this);
    _initializerDefineProperty(this, "updateDirection", _descriptor5, this);
    _initializerDefineProperty(this, "channelStatus", _descriptor6, this);
    _initializerDefineProperty(this, "checkForActions", _descriptor7, this);
    _initializerDefineProperty(this, "version", _descriptor8, this);
    _initializerDefineProperty(this, "revision", _descriptor9, this);
    _initializerDefineProperty(this, "lastAcknowledgedVersion", _descriptor10, this);
    _initializerDefineProperty(this, "lastAcknowledgedRevision", _descriptor11, this);
    _initializerDefineProperty(this, "lastAcknowledgedAt", _descriptor12, this);
    _initializerDefineProperty(this, "acknowledgmentStatus", _descriptor13, this);
    _initializerDefineProperty(this, "lastErroredAt", _descriptor14, this);
    _initializerDefineProperty(this, "errorDescription", _descriptor15, this);
    _initializerDefineProperty(this, "retryCount", _descriptor16, this);
    _initializerDefineProperty(this, "createdAt", _descriptor17, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor18, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor19, this);
    _initializerDefineProperty(this, "manuallyDisabled", _descriptor20, this);
    // Relationships
    _initializerDefineProperty(this, "platformObject", _descriptor21, this);
    _initializerDefineProperty(this, "channelObject", _descriptor22, this);
    _initializerDefineProperty(this, "objectMapAcknowledgmentErrors", _descriptor23, this);
    _initializerDefineProperty(this, "objectMapFieldMasks", _descriptor24, this);
    _initializerDefineProperty(this, "channel", _descriptor25, this);
  }
  get isChannelStatusDisabled() {
    return this.channelStatus === CHANNEL_STATUS.DISABLED;
  }
  get isChannelStatusPublished() {
    return this.channelStatus === CHANNEL_STATUS.PUBLISHED;
  }
  get isChannelStatusUnpublished() {
    return this.channelStatus === CHANNEL_STATUS.UNPUBLISHED;
  }
  get isAcknowledgementStatusSuccess() {
    return this.acknowledgmentStatus === ACKNOWLEDGMENT_STATUS.SUCCESS;
  }
  get isAcknowledgementStatusPending() {
    return this.acknowledgmentStatus === ACKNOWLEDGMENT_STATUS.PENDING;
  }
  get isAcknowledgementStatusUserError() {
    return this.acknowledgmentStatus === ACKNOWLEDGMENT_STATUS.USER_ERROR;
  }
  get isAcknowledgementStatusUserWarning() {
    return this.acknowledgmentStatus === ACKNOWLEDGMENT_STATUS.USER_WARNING;
  }
  get isAcknowledgementStatusSystemError() {
    return this.acknowledgmentStatus === ACKNOWLEDGMENT_STATUS.SYSTEM_ERROR;
  }
  get isListingEnabled() {
    return !this.manuallyDisabled;
  }
  get isPublishedStatus() {
    return (this.isAcknowledgementStatusSuccess || this.isAcknowledgementStatusUserWarning) && this.isChannelStatusPublished && this.channelObject?.isApproved;
  }
  get isRecommendedStatus() {
    return this.isAcknowledgementStatusUserWarning;
  }
  get isPendingStatus() {
    if (this.isAcknowledgementStatusPending) {
      return true;
    }
    if (this.isAcknowledgementStatusSuccess && this.isChannelStatusPublished && (this.channelObject?.isPending || this.channelObject?.isDisapproved)) {
      return true;
    }
    return false;
  }
  get isNeedsAttentionStatus() {
    return this.isAcknowledgementStatusSystemError || this.isAcknowledgementStatusUserError;
  }
  get statusToTranslationKey() {
    switch (this.status) {
      case LISTING_STATUS.PUBLISHED:
        return 'channelListings.common.status.published';
      case LISTING_STATUS.UNPUBLISHED:
        return 'channelListings.common.status.unpublished';
      case LISTING_STATUS.RECOMMENDED:
        return 'channelListings.common.status.suggestedEdits';
      case LISTING_STATUS.ERROR:
      case LISTING_STATUS.INVALID:
        return 'channelListings.common.status.needsAttention';
      case LISTING_STATUS.PENDING:
        return 'channelListings.common.status.pending';
      case LISTING_STATUS.DISABLED:
        return 'channelListings.common.status.disabled';
      default:
        return 'channelListings.common.status.pending';
    }
  }
  get status() {
    switch (true) {
      case this.isChannelStatusDisabled:
        return LISTING_STATUS.DISABLED;
      case this.isPendingStatus:
        return LISTING_STATUS.PENDING;
      case this.isAcknowledgementStatusSystemError:
        return LISTING_STATUS.ERROR;
      case this.isAcknowledgementStatusUserError:
        return LISTING_STATUS.INVALID;
      case this.isRecommendedStatus:
        return LISTING_STATUS.RECOMMENDED;
      case this.isChannelStatusUnpublished:
        return LISTING_STATUS.UNPUBLISHED;
      case this.isPublishedStatus:
        return LISTING_STATUS.PUBLISHED;
      default:
        return LISTING_STATUS.PENDING;
    }
  }
  get statusToC() {
    return capitalize(this.statusToL);
  }
  get statusToL() {
    return this.status.toLowerCase();
  }
  get errorTypeObjectMapAcknowledgmentErrors() {
    return this.objectMapAcknowledgmentErrors.filter(error => error.isErrorTypeError);
  }
  get warningTypeObjectMapAcknowledgmentWarnings() {
    return this.objectMapAcknowledgmentErrors.filter(error => error.isErrorTypeWarning);
  }
  get channelResolvableObjectMapAcknowledgmentErrors() {
    return this.errorTypeObjectMapAcknowledgmentErrors.filter(error => {
      return error.isOccurredByChannel && !error.errorIsGoogleShippingAndTaxError;
    });
  }
  get channelResolvableObjectMapShippingAndTaxAcknowledgementErrors() {
    return this.errorTypeObjectMapAcknowledgmentErrors.filter(error => {
      return error.isOccurredByChannel && error.errorIsGoogleShippingAndTaxError;
    });
  }
  updateListingStatus() {
    const adapter = this.store.adapterFor('channels/object-map');
    if (this.isListingEnabled) {
      return adapter.enableListingStatus([this.id]);
    } else {
      return adapter.disableListingStatus([this.id]);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "channelId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "platformObjectId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "channelObjectId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "updateDirection", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "channelStatus", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "checkForActions", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "revision", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "lastAcknowledgedVersion", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "lastAcknowledgedRevision", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "lastAcknowledgedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "acknowledgmentStatus", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "lastErroredAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "errorDescription", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "retryCount", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "manuallyDisabled", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "platformObject", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "channelObject", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "objectMapAcknowledgmentErrors", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "objectMapFieldMasks", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "channel", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isChannelStatusDisabled", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "isChannelStatusDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChannelStatusPublished", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "isChannelStatusPublished"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChannelStatusUnpublished", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "isChannelStatusUnpublished"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcknowledgementStatusSuccess", [_dec29], Object.getOwnPropertyDescriptor(_class.prototype, "isAcknowledgementStatusSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcknowledgementStatusPending", [_dec30], Object.getOwnPropertyDescriptor(_class.prototype, "isAcknowledgementStatusPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcknowledgementStatusUserError", [_dec31], Object.getOwnPropertyDescriptor(_class.prototype, "isAcknowledgementStatusUserError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcknowledgementStatusUserWarning", [_dec32], Object.getOwnPropertyDescriptor(_class.prototype, "isAcknowledgementStatusUserWarning"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcknowledgementStatusSystemError", [_dec33], Object.getOwnPropertyDescriptor(_class.prototype, "isAcknowledgementStatusSystemError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isListingEnabled", [_dec34], Object.getOwnPropertyDescriptor(_class.prototype, "isListingEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPublishedStatus", [_dec35], Object.getOwnPropertyDescriptor(_class.prototype, "isPublishedStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRecommendedStatus", [_dec36], Object.getOwnPropertyDescriptor(_class.prototype, "isRecommendedStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPendingStatus", [_dec37], Object.getOwnPropertyDescriptor(_class.prototype, "isPendingStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNeedsAttentionStatus", [_dec38], Object.getOwnPropertyDescriptor(_class.prototype, "isNeedsAttentionStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "statusToTranslationKey", [_dec39], Object.getOwnPropertyDescriptor(_class.prototype, "statusToTranslationKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "status", [_dec40], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "statusToC", [_dec41], Object.getOwnPropertyDescriptor(_class.prototype, "statusToC"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "statusToL", [_dec42], Object.getOwnPropertyDescriptor(_class.prototype, "statusToL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorTypeObjectMapAcknowledgmentErrors", [_dec43], Object.getOwnPropertyDescriptor(_class.prototype, "errorTypeObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "warningTypeObjectMapAcknowledgmentWarnings", [_dec44], Object.getOwnPropertyDescriptor(_class.prototype, "warningTypeObjectMapAcknowledgmentWarnings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "channelResolvableObjectMapAcknowledgmentErrors", [_dec45], Object.getOwnPropertyDescriptor(_class.prototype, "channelResolvableObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "channelResolvableObjectMapShippingAndTaxAcknowledgementErrors", [_dec46], Object.getOwnPropertyDescriptor(_class.prototype, "channelResolvableObjectMapShippingAndTaxAcknowledgementErrors"), _class.prototype), _class);
export { ObjectMap as default };